document.addEventListener("DOMContentLoaded", () => {
    const toggle = document.getElementById("hamburger-toggle");
    const menu = document.getElementById("mobile-menu");
    const iconOpen = document.getElementById("hamburger-icon");
    const iconClose = document.getElementById("close-icon");
    let scrollAnchor = 0;

    const closeMenu = () => {
        menu.classList.remove("opacity-100");
        menu.classList.add("opacity-0", "pointer-events-none");
        toggle.setAttribute("aria-expanded", "false");
        document.body.style.overflow = "";

        iconOpen.classList.remove("d-hidden");
        iconOpen.classList.add("d-block");
        iconClose.classList.remove("d-block");
        iconClose.classList.add("d-hidden");
    };

    toggle?.addEventListener("click", () => {
        const isOpen = toggle.getAttribute("aria-expanded") === "true";

        if (isOpen) {
            closeMenu();
        } else {
            scrollAnchor = window.scrollY;
            menu.classList.remove("opacity-0", "pointer-events-none");
            menu.classList.add("opacity-100");
            toggle.setAttribute("aria-expanded", "true");
            document.body.style.overflow = "hidden";

            iconOpen.classList.remove("d-block");
            iconOpen.classList.add("d-hidden");
            iconClose.classList.remove("d-hidden");
            iconClose.classList.add("d-block");
        }
    });

    // Escape key closes menu
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && toggle.getAttribute("aria-expanded") === "true") {
            closeMenu();
        }
    });

    // Close on scroll past 50px — handles iOS where overflow:hidden doesn't lock scroll
    window.addEventListener("scroll", () => {
        if (toggle.getAttribute("aria-expanded") === "true" && Math.abs(window.scrollY - scrollAnchor) > 50) {
            closeMenu();
        }
    }, { passive: true });
});
